var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-flag",class:_setup.baseFlagClasses},[_c('img',{attrs:{"src":require(`../../../assets/images/flags/${_setup.formattedCountry}.svg`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }